import { createContext, Dispatch, SetStateAction } from 'react'

import { CustomFormCommonEntity, CustomFormCommonEntityFilter } from '../../types'
import { CustomFormCommonEntitiesProps } from '../..'
import { Pagination } from 'types'

type CustomFormCommonEntityPropsManagerContextType = CustomFormCommonEntitiesProps & {
  view: string
  setView: Dispatch<SetStateAction<string>>
  selectedEntity: CustomFormCommonEntity
  setSelectedEntity: (newEntity: CustomFormCommonEntity) => void
  filter: CustomFormCommonEntityFilter
  setFilter: Dispatch<SetStateAction<CustomFormCommonEntityFilter>>
  entities: CustomFormCommonEntity[]
  invalidEntity: boolean
  loadingEntities: boolean
  setLoadingEntities: Dispatch<SetStateAction<boolean>>
  pagination: Pagination
  setPagination: Dispatch<SetStateAction<Pagination>>
  totalEntities: number
}

const defaultValue = {
  view: '',
  setView: () => {},
  pagination: {
    page: 1,
    limit: 100,
  },
  setPagination: () => {},
  totalEntities: 0,
  selectedEntity: {},
  setSelectedEntity: () => {},
  filter: {},
  setFilter: () => {},
  entities: [],
  invalidEntity: false,
  loadingEntities: false,
  setLoadingEntities: () => {},
  questionKey: '',
  currentEntity: {
    label: '',
    labelPlural: '',
    key: '',
    keyPlural: '',
  },
}

const CustomFormCommonEntityPropsManagerContext =
  createContext<CustomFormCommonEntityPropsManagerContextType>(defaultValue)

export default CustomFormCommonEntityPropsManagerContext
